// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "chunk-vendors" + "." + "9f06202e" + ".css";
};